import { ChangeEvent, Dispatch, SetStateAction } from "react";
import CustomLabel from "../../common/CustomLabel";
import { FilterCriteria } from "../../../types";
import Select from "react-select";
import CustomAccordion from "../../common/CustomAccordion";

const ReportAbuserInfoFilter = ({
  filterCriteria,
  setFilterCriteria,
}: {
  filterCriteria: FilterCriteria;
  setFilterCriteria: Dispatch<SetStateAction<FilterCriteria>>;
}) => {
  const handleAbuserInfoChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;

    setFilterCriteria((prev) => ({
      ...prev,
      abuserInfo: {
        ...prev.abuserInfo,
        [name]: value,
      },
    }));
  };

  const handleAbuserVehicleInfoChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;

    setFilterCriteria((prev) => ({
      ...prev,
      abuserInfo: {
        ...prev.abuserInfo,
        vehicleInfo: {
          ...prev.abuserInfo.vehicleInfo,
          [name]: value,
        },
      },
    }));
  };

  return (
    <CustomAccordion label="Abuser Details" defaultOpen={true}>
      <div className="flex flex-col gap-4">
        <CustomLabel
          labelText="Abuser Name"
          labelTextClass="px-4"
          labelWrapClass="!gap-1"
        >
          <input
            type="text"
            name="name"
            placeholder="Select abuser's name"
            className="font-medium text-[14px] leading-4 text-gray-7 w-full border border-gray-3 rounded-3xl py-4 px-4 outline-none focus:ring-1 focus:ring-black focus:border-transparent cursor-pointer"
            value={filterCriteria.abuserInfo.name}
            onChange={handleAbuserInfoChange}
          />
        </CustomLabel>

        <CustomLabel
          labelText="Abuser Alias"
          labelTextClass="px-4"
          labelWrapClass="!gap-1"
        >
          <input
            type="text"
            name="alias"
            placeholder="Enter abuser's alias"
            className="font-medium text-[14px] leading-4 text-gray-7 w-full border border-gray-3 rounded-3xl py-4 px-4 outline-none focus:ring-1 focus:ring-black focus:border-transparent cursor-pointer"
            value={filterCriteria.abuserInfo.alias}
            onChange={handleAbuserInfoChange}
          />
        </CustomLabel>

        <CustomLabel
          labelText="Abuser Gender"
          labelTextClass="px-4"
          labelWrapClass="!gap-1"
        >
          <input
            type="text"
            name="gender"
            placeholder="Enter abuser's gender"
            className="font-medium text-[14px] leading-4 text-gray-7 w-full border border-gray-3 rounded-3xl py-4 px-4 outline-none focus:ring-1 focus:ring-black focus:border-transparent cursor-pointer"
            value={filterCriteria.abuserInfo.gender}
            onChange={handleAbuserInfoChange}
          />
        </CustomLabel>

        <CustomLabel
          labelText="Abuser Reference Age"
          labelTextClass="px-4"
          labelWrapClass="!gap-1"
        >
          <input
            type="text"
            name="refAge"
            placeholder="Select abuser's reference age"
            className="font-medium text-[14px] leading-4 text-gray-7 w-full border border-gray-3 rounded-3xl py-4 px-4 outline-none focus:ring-1 focus:ring-black focus:border-transparent cursor-pointer"
            value={filterCriteria.abuserInfo.refAge}
            onChange={handleAbuserInfoChange}
          />
        </CustomLabel>

        <CustomLabel
          labelText="Abuser Relation"
          labelTextClass="px-4"
          labelWrapClass="!gap-1"
        >
          <input
            type="text"
            name="relation"
            placeholder="Enter abuser's relation to the victim"
            className="font-medium text-[14px] leading-4 text-gray-7 w-full border border-gray-3 rounded-3xl py-4 px-4 outline-none focus:ring-1 focus:ring-black focus:border-transparent cursor-pointer"
            value={filterCriteria.abuserInfo.relation}
            onChange={handleAbuserInfoChange}
          />
        </CustomLabel>

        <CustomLabel
          labelText="Abuser Occupation"
          labelTextClass="px-4"
          labelWrapClass="!gap-1"
        >
          <input
            type="text"
            name="occupation"
            placeholder="Enter abuser's occupation"
            className="font-medium text-[14px] leading-4 text-gray-7 w-full border border-gray-3 rounded-3xl py-4 px-4 outline-none focus:ring-1 focus:ring-black focus:border-transparent cursor-pointer"
            value={filterCriteria.abuserInfo.occupation}
            onChange={handleAbuserInfoChange}
          />
        </CustomLabel>

        <CustomLabel
          labelText="Abuser Ethnicity"
          labelTextClass="px-4"
          labelWrapClass="!gap-1"
        >
          <input
            type="text"
            name="ethnicity"
            placeholder="Enter abuser's ethnicity"
            className="font-medium text-[14px] leading-4 text-gray-7 w-full border border-gray-3 rounded-3xl py-4 px-4 outline-none focus:ring-1 focus:ring-black focus:border-transparent cursor-pointer"
            value={filterCriteria.abuserInfo.ethnicity}
            onChange={handleAbuserInfoChange}
          />
        </CustomLabel>

        <CustomLabel
          labelText="Abuser Has Special Authority"
          labelTextClass="px-4"
          labelWrapClass="!gap-1"
        >
          <Select
            isSearchable={false}
            placeholder="Select has abuser special authority"
            components={{
              IndicatorSeparator: () => null,
            }}
            options={[
              { label: "Yes", value: true },
              { label: "No", value: false },
            ]}
            onChange={(selectedOption) =>
              setFilterCriteria((prev) => ({
                ...prev,
                abuserInfo: {
                  ...prev.abuserInfo,
                  hasSpecialAuthority: selectedOption?.value,
                },
              }))
            }
            styles={{
              control: (provided) => ({
                ...provided,
                borderRadius: "24px",
                padding: "8px 8px",
              }),
              option: (provided, state) => ({
                ...provided,
                backgroundColor: state.isSelected ? "#ddd" : "transparent",
              }),
            }}
          />
        </CustomLabel>

        {filterCriteria.abuserInfo.hasSpecialAuthority && (
          <CustomLabel
            labelText="Abuser Authority Position"
            labelTextClass="px-4"
            labelWrapClass="!gap-1"
          >
            <input
              type="text"
              name="authorityPosition"
              placeholder="Enter abuser's authority position"
              className="font-medium text-[14px] leading-4 text-gray-7 w-full border border-gray-3 rounded-3xl py-4 px-4 outline-none focus:ring-1 focus:ring-black focus:border-transparent cursor-pointer"
              value={filterCriteria.abuserInfo.authorityPosition}
              onChange={handleAbuserInfoChange}
            />
          </CustomLabel>
        )}

        <CustomLabel
          labelText="Abuser Physical Description"
          labelTextClass="px-4"
          labelWrapClass="!gap-1"
        >
          <input
            type="text"
            name="phyDescription"
            placeholder="Enter abuser's physical description"
            className="font-medium text-[14px] leading-4 text-gray-7 w-full border border-gray-3 rounded-3xl py-4 px-4 outline-none focus:ring-1 focus:ring-black focus:border-transparent cursor-pointer"
            value={filterCriteria.abuserInfo.phyDescription}
            onChange={handleAbuserInfoChange}
          />
        </CustomLabel>

        {/* Select */}
        <CustomLabel
          labelText="Has Abuser Vehicle Info"
          labelTextClass="px-4"
          labelWrapClass="!gap-1"
        >
          <Select
            isSearchable={false}
            placeholder="Select has abuser vehicle info"
            components={{
              IndicatorSeparator: () => null,
            }}
            options={[
              { label: "Yes", value: true },
              { label: "No", value: false },
            ]}
            onChange={(selectedOption) =>
              setFilterCriteria((prev) => ({
                ...prev,
                abuserInfo: {
                  ...prev.abuserInfo,
                  hasAbuserVehicleInfo: selectedOption?.value,
                },
              }))
            }
            styles={{
              control: (provided) => ({
                ...provided,
                borderRadius: "24px",
                padding: "8px 8px",
              }),
              option: (provided, state) => ({
                ...provided,
                backgroundColor: state.isSelected ? "#ddd" : "transparent",
              }),
            }}
          />
        </CustomLabel>

        {filterCriteria.abuserInfo.hasAbuserVehicleInfo && (
          <>
            <CustomLabel
              labelText="Abuser Vehicle Brand"
              labelTextClass="px-4"
              labelWrapClass="!gap-1"
            >
              <input
                type="text"
                name="brand"
                placeholder="Enter abuser vehicle brand"
                className="font-medium text-[14px] leading-4 text-gray-7 w-full border border-gray-3 rounded-3xl py-4 px-4 outline-none focus:ring-1 focus:ring-black focus:border-transparent cursor-pointer"
                value={filterCriteria.abuserInfo.vehicleInfo?.brand}
                onChange={handleAbuserVehicleInfoChange}
              />
            </CustomLabel>

            <CustomLabel
              labelText="Abuser Vehicle Model"
              labelTextClass="px-4"
              labelWrapClass="!gap-1"
            >
              <input
                type="text"
                name="model"
                placeholder="Enter abuser vehicle model"
                className="font-medium text-[14px] leading-4 text-gray-7 w-full border border-gray-3 rounded-3xl py-4 px-4 outline-none focus:ring-1 focus:ring-black focus:border-transparent cursor-pointer"
                value={filterCriteria.abuserInfo.vehicleInfo?.model}
                onChange={handleAbuserVehicleInfoChange}
              />
            </CustomLabel>

            <CustomLabel
              labelText="Abuser Vehicle Color"
              labelTextClass="px-4"
              labelWrapClass="!gap-1"
            >
              <input
                type="text"
                name="carColor"
                placeholder="Enter abuser vehicle color"
                className="font-medium text-[14px] leading-4 text-gray-7 w-full border border-gray-3 rounded-3xl py-4 px-4 outline-none focus:ring-1 focus:ring-black focus:border-transparent cursor-pointer"
                value={filterCriteria.abuserInfo.vehicleInfo?.carColor}
                onChange={handleAbuserVehicleInfoChange}
              />
            </CustomLabel>

            <CustomLabel
              labelText="Abuser Vehicle License Plate"
              labelTextClass="px-4"
              labelWrapClass="!gap-1"
            >
              <input
                type="text"
                name="licensePlate"
                placeholder="Enter abuser license plate"
                className="font-medium text-[14px] leading-4 text-gray-7 w-full border border-gray-3 rounded-3xl py-4 px-4 outline-none focus:ring-1 focus:ring-black focus:border-transparent cursor-pointer"
                value={filterCriteria.abuserInfo.vehicleInfo?.licensePlate}
                onChange={handleAbuserVehicleInfoChange}
              />
            </CustomLabel>
          </>
        )}
      </div>
    </CustomAccordion>
  );
};

export default ReportAbuserInfoFilter;
